import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, mergeProps as _mergeProps, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-04457aa2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "oxd-switch-wrapper" }
const _hoisted_2 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", {
      class: _normalizeClass({'--disabled': _ctx.disabled})
    }, [
      (_ctx.labelPosition === 'left')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createTextVNode(_toDisplayString(_ctx.optionLabel), 1)
          ], 64))
        : _createCommentVNode("", true),
      _withDirectives(_createElementVNode("input", _mergeProps({
        type: "checkbox",
        onFocus: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onFocus && _ctx.onFocus(...args))),
        onBlur: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onBlur && _ctx.onBlur(...args))),
        onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onChange && _ctx.onChange(...args)))
      }, _ctx.$attrs, {
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.checked) = $event)),
        disabled: _ctx.disabled
      }), null, 16, _hoisted_2), [
        [_vModelCheckbox, _ctx.checked]
      ]),
      _createElementVNode("span", {
        class: _normalizeClass(_ctx.classes),
        style: _normalizeStyle(_ctx.style)
      }, null, 6),
      (_ctx.labelPosition === 'right')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createTextVNode(_toDisplayString(_ctx.optionLabel), 1)
          ], 64))
        : _createCommentVNode("", true)
    ], 2)
  ]))
}